// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNav-TableOfContents-module--cls1--11ARC","cls2":"SideNav-TableOfContents-module--cls2--1iPNK SideNav-TableOfContents-module--cls1--11ARC pt-2 pb-4"};